"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSavedSearchSetByDistrictId = exports.hasSavedSearchSetByKeyword = exports.getSearchSetDetailApiToken = exports.unsubscribeToken = exports.setUserSubscribeToken = exports.removeSaveSearchToken = exports.getSearchCriteriaToken = exports.saveSearchSetsToken = exports.saveSearchCriteriaToken = void 0;
var Api_1 = require("@/api/remote/Api");
var SaveSearchSet_1 = require("@/pages/common/states/SaveSearchSet");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
exports.saveSearchCriteriaToken = function (saveSearchSet, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/saved-search/savesearchset",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: __assign(__assign({}, saveSearchSet), { isCustomName: true }),
    });
};
exports.saveSearchSetsToken = function (saveSearchSets, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/saved-search/savesearchsets",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: saveSearchSets.map(function (it) { return (__assign(__assign({}, it), { isCustomName: true })); }),
    });
};
exports.getSearchCriteriaToken = function (languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/saved-search/getsearchsets",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: {
            pageSize: 1000,
        },
    }).then(function (res) {
        if (res.data && res.data.searchSets) {
            res.data.searchSets = res.data.searchSets.map(function (it) {
                return __assign(__assign({}, it), { district: it.district || '', area: it.area || '' });
            });
        }
        return res;
    });
};
exports.removeSaveSearchToken = function (id, languageCode, token) {
    return Api_1.api().request({
        method: 'GET',
        url: languageCode + "/api/saved-search/deleteusersearchset/" + id,
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.setUserSubscribeToken = function (state, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/communication/savesubscriptions",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: [
            {
                subscriptionType: 1,
                subscribed: state,
            },
        ],
    });
};
exports.unsubscribeToken = function (languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/communication/unsubscribe",
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.getSearchSetDetailApiToken = function (id, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/saved-search/getsearchsetbyids",
        data: {
            searchSetIds: [id],
        },
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.hasSavedSearchSetByKeyword = function (keyword, type, languageCode, token, searchResultType, searchResultId) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/saved-search/hasSavedSearchSetByKeyword",
        data: {
            keyword: keyword,
            searchSaveSetType: SaveSearchSet_1.SearchSaveSetType.Building,
            listingPurposeType: SfilterTypeGroup_1.SfilterType.toListingPurposeType(type),
            searchResultType: searchResultType, searchResultId: searchResultId
        },
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.hasSavedSearchSetByDistrictId = function (districtId, type, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/saved-search/hasSavedSearchSetByDistrictId",
        data: {
            districtId: districtId,
            searchSaveSetType: SaveSearchSet_1.SearchSaveSetType.District,
            listingPurposeType: SfilterTypeGroup_1.SfilterType.toListingPurposeType(type),
        },
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
